import { useContext } from 'react';
import RouterScrollContext from './context';

const useRouterScroll = () => useContext(RouterScrollContext);

export default useRouterScroll;